// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__E3Nv2","question":"Question_question__1oTRw","description":"Question_description__1mMis"};